'use client';

import { createContext, ReactNode, useContext } from 'react';

interface WebViewServiceContextType {
  postMessage?: (message: { type: string; data?: unknown }) => void;
}

const WebViewServiceContext = createContext<WebViewServiceContextType>({});

export const WebViewServiceProvider = ({
  children,
  webViewService,
}: {
  children: ReactNode;
  webViewService?: WebViewServiceContextType;
}) => {
  return (
    <WebViewServiceContext.Provider value={webViewService || {}}>
      {children}
    </WebViewServiceContext.Provider>
  );
};

export const useWebViewService = () => useContext(WebViewServiceContext);
